import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-brand-teal py-24 px-6 text-brand-ivory">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 mb-24">
          <div className="max-w-xs">
            <Link to="/" className="text-2xl font-heading font-extrabold tracking-widest uppercase mb-8 block">LB . BH</Link>
            <p className="text-sm font-light leading-relaxed mb-8 opacity-80 italic serif-italic">
              "A sanctuary for creativity. Where Calgary brands, storytellers, and creators find their voice."
            </p>
            <div className="space-y-2">
              <p className="text-[10px] font-bold tracking-widest uppercase text-brand-orange">Contact</p>
              <a href="mailto:connect@lbbrandhaus.com" className="text-sm block">connect@lbbrandhaus.com</a>
              <p className="text-sm">368-599-0012</p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8">
            <div className="space-y-6">
              <h4 className="text-[10px] font-bold tracking-widest uppercase text-brand-orange">Studio</h4>
              <ul className="space-y-4 text-sm opacity-70">
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/studio">The Space</Link></li>
                <li><Link to="/booking">Booking</Link></li>
              </ul>
            </div>
            <div className="space-y-6">
              <h4 className="text-[10px] font-bold tracking-widest uppercase text-brand-orange">Connect</h4>
              <ul className="space-y-4 text-sm opacity-70">
                <li><a href="https://www.instagram.com/lbbrandhaus/" target="_blank">Instagram</a></li>
                <li><a href="https://www.linkedin.com/company/lbbrandhaus/" target="_blank">LinkedIn</a></li>
                <li><Link to="/terms">Terms</Link></li>
              </ul>
            </div>
          </div>

          <div className="space-y-6">
            <h4 className="text-[10px] font-bold tracking-widest uppercase text-brand-orange">Address</h4>
            <p className="text-sm leading-relaxed opacity-70">
              Unit H38, New Horizon Mall<br />
              260300 Writing Creek Cres<br />
              Balzac, AB T4A 0X8
            </p>
          </div>
        </div>
        
        <div className="pt-12 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6 opacity-50 text-[9px] tracking-[0.4em] uppercase">
          <p>© {new Date().getFullYear()} LB BRAND HAUS</p>
          <p>Designed by Silahub Creative Studio</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;